'use client';

import { useState } from 'react';
import { createPortal } from 'react-dom';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useAuth } from '@/contexts/AuthContext';
import PeopleSearch from '@/app/community-network/components/PeopleSearch';

export default function GlobalPeopleSearch() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} aria-label="Find people" title="Find people"
        className="flex items-center gap-2 rounded-xl p-2 text-muted-foreground hover:bg-muted hover:text-foreground">
        <MagnifyingGlassIcon className="h-5 w-5" />
        <span className="hidden lg:inline text-sm font-semibold">Find people</span>
      </button>
      {open && createPortal(
        <PeopleSearch key={user?.id || 'guest'} currentUserId={user?.id} onClose={() => setOpen(false)} />,
        document.body,
      )}
    </>
  );
}
